import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import useGetFetchConfig from '../useGetFetchConfig';

interface UseDownloadThreadFileProps {
  matterId: string;
  subsetId: string;
  threadId: string;
  fileId: string;
  fileName?: string;
}

export const useDownloadThreadFile = ({
  matterId,
  subsetId,
  threadId,
  fileId,
  fileName,
}: UseDownloadThreadFileProps) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useMutation(
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/files/${fileId}`,
        fetchConfigGET,
      );
      if (!res.ok) {
        throw new Error('Failed to fetch download URL');
      }
      const data: { downloadUrl: string } = await res.json();

      const link = document.createElement('a');
      link.href = data.downloadUrl;
      link.download = fileName || `wexler-file-${fileId}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    {
      onError: () => {
        toast.error('Failed to download file');
      },
    },
  );
};
